import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getProjectQaWeldingInspectionsInspectionSpecs } from "../actions";

function mapStateToProps(state) {
  return {
    project_qa_welding_inspections_inspection_specs: state.project_qa_welding_inspections_inspection_specs,
  };
}

const ProjectQaWeldingInspectionsInspectionSpecsIndex = (props) => {
  useEffect(() => {
    props.getProjectQaWeldingInspectionsInspectionSpecs();
  }, []);

  const { project_qa_welding_inspections_inspection_specs } = props;

  const readRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::InspectionSpec", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::InspectionSpec", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::InspectionSpec", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Inspection specs</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/project/qa/welding_inspections/inspection_specs/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Inspection spec</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={project_qa_welding_inspections_inspection_specs} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getProjectQaWeldingInspectionsInspectionSpecs })(ProjectQaWeldingInspectionsInspectionSpecsIndex);
